/* GeoChange V2 — complimentary print (rebuilt 2026-09-17)
   Mechanic = the store's live FREEGIFT codes ("Spend $250, get 1 item free", per-artist rolled variants).
   The drawer is server-rendered: [data-ladder] carries eligibility (art subtotal ≥ threshold, gift excluded),
   the current gift line and its variant. This script only:
     choose(): remove any previous gift line, add the chosen variant as a real line with _gc_gift properties,
               attach the artist's code to the checkout (/discount/CODE), record the choice on the cart, refresh.
     reconcile(): after every drawer refresh, if the cart is no longer eligible the gift line is removed and the
               attributes cleared, so a benefit never lingers; a gift line is also held at quantity 1.
   No polling, no reload, no timers, no unbounded observers. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ATTR = 'Complimentary print';
  var busy = false;

  function sheet() { return $('#gc-gift-sheet'); }
  function ladder() { return $('#gc-cart-drawer [data-ladder]') || $('.cartpg [data-ladder]'); }

  function openSheet() {
    var s = sheet(); if (!s) return;
    $$('.sheet').forEach(function (x) { if (x !== s) x.classList.remove('on'); });
    $$('img[loading="lazy"]', s).forEach(function (i) { i.loading = 'eager'; });
    s.classList.add('on');
    document.body.classList.remove('show-cart');
    document.body.classList.add('show-sheet');
    var f = $('[data-close-sheet]', s); if (f) f.focus();
  }
  function closeSheet() {
    var s = sheet(); if (!s) return;
    s.classList.remove('on');
    document.body.classList.remove('show-sheet');
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || url); return j; }); });
  }
  function updateAttributes(attrs) { return post('/cart/update.js', { attributes: attrs }); }
  function removeVariant(id) { return post('/cart/change.js', { id: String(id), quantity: 0 }); }
  function attachCode(code) {
    /* Shopify applies a discount code to the session when /discount/CODE is requested. The redirect is not
       followed; the Set-Cookie on the response is what matters. */
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', { credentials: 'same-origin', redirect: 'manual' }).catch(function () {});
  }

  /* PDP pre-choice (2026-09-17): a print chosen before the cart qualifies is remembered for the session and
     added automatically the moment the order passes the threshold. Nothing is claimed as free before then. */
  var PEND = 'gc_gift_pending';
  function loadPending() { try { return JSON.parse(sessionStorage.getItem(PEND) || 'null'); } catch (e) { return null; } }
  function savePending(d) { try { if (d) sessionStorage.setItem(PEND, JSON.stringify(d)); else sessionStorage.removeItem(PEND); } catch (e) {} }
  function dataOf(btn) { return { pick: btn.dataset.giftPick, code: btn.dataset.giftCode, title: btn.dataset.giftTitle, vendor: btn.dataset.giftVendor, size: btn.dataset.giftSize }; }
  function showPendingNote(d) {
    var n = $('[data-gift-mech]');
    if (n) n.textContent = d ? ('Saved: ' + d.title + ' by ' + d.vendor + '. It is added to your order, at $0, the moment the order passes the threshold.') : '';
    var pl = $('[data-gift-text]');
    if (pl && d) pl.textContent = 'Your complimentary print is chosen: ' + d.title + '. It joins your order at $0 once it qualifies.';
  }
  function choose(btn) {
    if (busy) return;
    var d = dataOf(btn);
    var L = ladder();
    var eligible = L && L.dataset.eligible === 'true';
    if (!eligible) { savePending(d); showPendingNote(d); setTimeout(closeSheet, 900); return; }
    apply(d, btn);
  }
  function apply(d, btn) {
    if (busy) return; busy = true;
    if (btn) btn.classList.add('busy');
    var L = ladder();
    var prev = L && L.dataset.giftVariant;
    var code = d.code;
    var label = d.title + ' · ' + d.vendor + ' · ' + d.size + ' · rolled · code ' + code;
    var attrs = {}; attrs[ATTR] = label; attrs['_gc_gift_code'] = code; attrs['_gc_gift_variant'] = d.pick;
    Promise.resolve()
      .then(function () { if (prev && prev !== d.pick) return removeVariant(prev); })
      .then(function () { if (prev === d.pick) return null; return post('/cart/add.js', { items: [{ id: +d.pick, quantity: 1, properties: { _gc_gift: 'true', _gc_gift_code: code } }] }); })
      .then(function () { return updateAttributes(attrs); })
      .then(function () { return window.GCDiscounts ? window.GCDiscounts.sync() : attachCode(code); })
      .then(function () { savePending(null); if (window.GCTrack) GCTrack('gift_selected', { variant: d.pick, code: code }); return window.GCCart ? window.GCCart.refresh() : null; })
      .then(function () { closeSheet(); if (window.GCCart) window.GCCart.open(); })
      .catch(function (e) {
        var n = $('[data-gift-mech]');
        if (n) n.textContent = 'That choice could not be added just now. Please try again.';
        if (window.console) console.warn('[gc-gift]', e);
      })
      .then(function () { busy = false; if (btn) btn.classList.remove('busy'); });
  }

  /* PRE-LAUNCH CLOSEOUT 2026-09-22 (Alex): the gift is re-validated against the LIVE cart (/cart.js), not only the server-rendered
     ladder. Rule = the approved theme rule: art subtotal (lines whose product has a Frame option, gift line excluded) ≥ threshold.
     Runs after every cart mutation (GCCart.refresh hook), on load, on pageshow, and once before checkout. If eligibility is lost the
     gift line is removed at once, the gift attributes and codes are cleared, and the drawer is refreshed. */
  function thresholdCents() { var L = ladder(); var t = L && +L.dataset.threshold; if (t > 0) return t; if (window.GC_GIFT && +window.GC_GIFT.threshold > 0) return +window.GC_GIFT.threshold; return 25000; }
  var validating = null;
  function validate() {
    if (validating) return validating;
    validating = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var gift = null, art = 0;
      (c.items || []).forEach(function (i) {
        var pr = i.properties || {};
        if (pr._gc_gift === 'true') { gift = i; return; }
        var isArt = (i.options_with_values || []).some(function (o) { return o && o.name === 'Frame'; });
        if (isArt) art += (i.final_line_price != null ? i.final_line_price : i.line_price) || 0;
      });
      var eligible = art >= thresholdCents();
      if (gift && !eligible) {
        var clear = {}; clear[ATTR] = ''; clear['_gc_gift_code'] = ''; clear['_gc_gift_variant'] = '';
        return post('/cart/change.js', { id: String(gift.key), quantity: 0 })
          .then(function () { return updateAttributes(clear); })
          .then(function () { return window.GCDiscounts ? window.GCDiscounts.sync() : null; })
          .then(function () { if (window.GCTrack) GCTrack('gift_removed_ineligible'); return { removed: true, eligible: false }; });
      }
      /* 2026-09-23: codes follow the cart. Applied (c.discount_codes) must equal GCDiscounts.desired(c): a Pair Price pair
         suppresses the FREEGIFT code (the Function makes the print $0); breaking the pair puts the code back. One extra
         /cart/update.js only when they differ. */
      var D = window.GCDiscounts;
      if (D && D.desired) {
        var want = D.desired(c).slice().sort().join(','), have = (c.discount_codes || []).map(function (d) { return d.code; }).sort().join(',');
        if (want !== have) return D.sync(c).then(function () { return { removed: false, eligible: eligible, gift: !!gift, resynced: true }; });
      }
      return { removed: false, eligible: eligible, gift: !!gift };
    }).catch(function (e) { if (window.console) console.warn('[gc-gift validate]', e); return { removed: false, error: true }; })
      .then(function (v) { validating = null; return v; });
    return validating;
  }
  /* one final validation before checkout, capped at 1.5 s so it never delays the customer */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!(f instanceof HTMLFormElement) || !f.querySelector('button[name="checkout"]')) return;
    if (f._gcValidated) { f._gcValidated = false; return; }
    e.preventDefault(); var btn = f.querySelector('button[name="checkout"]'); if (btn) btn.classList.add('busy');
    var done = false; var go = function () { if (done) return; done = true; f._gcValidated = true; if (f.requestSubmit) f.requestSubmit(btn); else f.submit(); };
    Promise.race([validate(), new Promise(function (r) { setTimeout(r, 1500); })]).then(go, go);
  }, true);
  window.addEventListener('pageshow', function () { validate().then(function (v) { if (v && v.removed && window.GCCart) window.GCCart.refresh(); }); });

  /* Fail safe: no eligibility, no gift line. */
  var reconciling = false;
  function reconcile() {
    if (reconciling) return;
    var L = ladder(); if (!L) return;
    var eligible = L.dataset.eligible === 'true';
    var gv = L.dataset.giftVariant;
    var gq = +(L.dataset.giftQty || 0);
    if (eligible && !L._gcUnlockedSeen) { L._gcUnlockedSeen = true; if (!window._gcGiftUnlocked) { window._gcGiftUnlocked = true; if (window.GCTrack) GCTrack('gift_unlocked'); } }
    if (gv && !eligible) {
      reconciling = true;
      var clear = {}; clear[ATTR] = ''; clear['_gc_gift_code'] = ''; clear['_gc_gift_variant'] = '';
      removeVariant(gv).then(function () { return updateAttributes(clear); })
        .then(function () { return window.GCDiscounts ? window.GCDiscounts.sync() : null; })
        .then(function () { return window.GCCart ? window.GCCart.refresh() : null; })
        .catch(function (e) { if (window.console) console.warn('[gc-gift reconcile]', e); })
        .then(function () { reconciling = false; });
      return;
    }
    /* a pending PDP choice is applied as soon as the order qualifies */
    var pend = loadPending();
    if (eligible && !gv && pend && pend.pick && !busy) { apply(pend, null); return; }
    if (gv && gq > 1) {
      reconciling = true;
      post('/cart/change.js', { id: String(gv), quantity: 1 })
        .then(function () { return window.GCCart ? window.GCCart.refresh() : null; })
        .catch(function () {})
        .then(function () { reconciling = false; });
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-gift]')) { e.preventDefault(); openSheet(); return; }
    if (e.target.closest('#gc-gift-sheet [data-close-sheet]') || e.target.closest('#gc-gift-sheet .scrim')) { e.preventDefault(); closeSheet(); return; }
    var pick = e.target.closest('[data-gift-pick]');
    if (pick) {
      e.preventDefault();
      $$('[data-gift-pick]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      pick.setAttribute('aria-checked', 'true');
      choose(pick);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  function hook() {
    if (!window.GCCart || window.GCCart._giftHooked) return;
    window.GCCart._giftHooked = true;
    var orig = window.GCCart.refresh.bind(window.GCCart);
    window.GCCart.refresh = function () { return orig().then(function (v) { reconcile(); validate().then(function (r) { if (r && r.removed) orig().then(function () { reconcile(); }); }); return v; }); };
    reconcile(); validate().then(function (r) { if (r && r.removed && window.GCCart) window.GCCart.refresh(); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', hook); } else { hook(); }
  document.addEventListener('DOMContentLoaded', function () { var d = loadPending(); if (d) showPendingNote(d); });
  window.GCGift = { reconcile: reconcile, validate: validate, open: openSheet };
})();
